import { render } from "./ConnectPublicationsModal.vue?vue&type=template&id=7306a173"
import script from "./ConnectPublicationsModal.vue?vue&type=script&lang=js"
export * from "./ConnectPublicationsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__